import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { ReactComponent as CircleStarIcon } from '../../assets/images/circle-star.svg';
import { ReactComponent as FlagIcon } from '../../assets/images/flag.svg';
import { ReactComponent as UserPlusIcon } from '../../assets/images/user-plus.svg';
import KeyboardDoubleArrowRight from '../../assets/svgComponents/KeyboardArrowRight';

import styles from './ReferralProcess.module.scss';

export const ReferralProcess = () => {
  const { t } = useTranslation('common');
  const steps = [
    {
      icon: <UserPlusIcon />,
      text: t('referralProcess.step1'),
    },
    {
      icon: <FlagIcon />,
      text: t('referralProcess.step2'),
    },
    {
      icon: <CircleStarIcon />,
      text: t('referralProcess.step3'),
    },
  ];
  return (
    <div className={classNames(styles.processContainer, 'max-md:hidden')}>
      <h4>{t('referralProcess.title')}</h4>
      <div className={styles.stepRow}>
        {steps.map((step, index) => (
          <React.Fragment key={`step-${step.text.replace(/\s+/g, '-').toLowerCase()}`}>
            <div className={styles.stepBox}>
              <div className={styles.icon}>{step.icon}</div>
              <p>{step.text}</p>
            </div>
            {index !== steps.length - 1 && (
              <div className={styles.arrow}>
                <KeyboardDoubleArrowRight />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
